import moment from "moment";
import {hideAlert, hideSuccessAlert, showAlert, showSuccessAlert} from "../store/actions/common";

export const prepareFormParams = (params) => {
    return Object.keys(params).map((key) => {
        if (typeof params[key] === 'object') {
            params[key] = prepareFormParams(params[key]);
        }
        return encodeURIComponent(key) + '=' + encodeURIComponent(params[key]);
    }).join('&');
}

export const superSplit = (str = '') => {
    let s = str.replace(/\,/g, ' ');
    s = s.replace(/\n/g, ' ');
    s = s.replace(/\./g, ' ');
    let exp = / /;
    let arr = s.split(exp);
    return arr.filter((elem) => {
        return elem;
    })

}

export const removeItemFromArray = (array, elem) => {

    let index = array.indexOf(elem);
    if (index > -1) {
        array.splice(index, 1)
        return array;
    }
    return array
}

export function onlyUnique(value, index, array) {
    return array.indexOf(value) === index;
}



export const handleError = (err, reject, dispatch = null) => {
    dispatch && showFAlert('Ошибка', err.data ? err.data.message : 'Что-то пошло не так...' , dispatch);
}

export function showSAlert(a, b, dispatch) {
    dispatch(showSuccessAlert(a, b));
    setTimeout(() => dispatch(hideSuccessAlert()), 30000)
}

export function showFAlert(a, b, dispatch) {
    dispatch(showAlert(a, b))
    setTimeout(() => dispatch(hideAlert()), 30000)
}

export const decodeEntities = (function() {
    // this prevents any overhead from creating the object each time
    var element = document.createElement('div');

    function decodeHTMLEntities (str) {
        if(str && typeof str === 'string') {
            // strip script/html tags
            str = str.replace(/<script[^>]*>([\S\s]*?)<\/script>/gmi, '');
            str = str.replace(/<\/?\w(?:[^"'>]|"[^"]*"|'[^']*')*>/gmi, '');
            element.innerHTML = str;
            str = element.textContent;
            element.textContent = '';
        }

        return str;
    }

    return decodeHTMLEntities;
})();

export function convertTZ(date, tzString) {
    return new Date((typeof date === "string" ? new Date(date) : date).toLocaleString("en-US", {timeZone: tzString}));
}

export function setStateToLocalStorage(moduleName, state) {
    let itemName = 'StoredState_' + moduleName;
    let data = JSON.stringify(state);
    localStorage.setItem(itemName, data);
}

export function getStateFromLocalStorage(moduleName) {
    let itemName = 'StoredState_' + moduleName;
    let data = localStorage.getItem(itemName);
    if (!data) {
        return null;
    }
    let res
    try {
        res = JSON.parse(data)
    } catch (e) {
        res = null;
    }
    
    return res;
}

// client_stat created_at/updated_at come back as naive strings (raw DB::table(), no Carbon casting).
// On production these are written in UTC (confirmed against prod DB: values match MySQL's own UTC
// NOW()) — parse as UTC, display in browser-local time.
export function formattedDateTime(str) {
    if (!str) return '';
    return moment.utc(str).local().format('YYYY-MM-DD HH:mm:ss');
}

export function formattedDate(str) {
    let d = new Date(str)
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());

    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;

    return `${day}.${month}.${year}`;
}

const months=[
  'Январь',
  'Февраль',
  'Март',
  'Апрель',
  'Май',
  'Июнь',
  'Июль',
  'Август',
  'Сентябрь',
  'Октябрь',
  'Ноябрь',
  'Декабрь',
];


export const getMonth = date => months[date.getMonth()];